/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import check from '../assets/icons/check.svg';

import link from '../assets/icons/Link.svg';
import hamburger from '../assets/icons/hamburger.png';
import logo from '../assets/images/sst_phs_logo_rgb.svg';
import User from '../assets/icons/User.svg';
import { useNavigate } from 'react-router-dom';
const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();
  const handleNav = () => {
    if (window.innerWidth > 1099) {
      let link1 = document.querySelector('#open-1');
      let link2 = document.querySelector('#open-2');
      document.querySelectorAll('.navbar .nav-item').forEach((element) => {
        element.addEventListener('mouseover', function () {
          // item.classList.add('addUnderline');
          if (element.id === 'Ratgeber') {
            link1.classList.remove('d-none');
            link1.classList.add('d-block');
          }
          if (element.id === 'Partner werden') {
            link2.classList.remove('d-none');
            link2.classList.add('d-block');
          }
        });
        link1.addEventListener('mouseover', function () {
          let item = this.querySelector('a');
          // item.classList.add('addUnderline');
          link1.classList.remove('d-none');
          link1.classList.add('d-block');
          console.log(item);
        });
        link2.addEventListener('mouseover', function () {
          let link = document.querySelector('#open-2');
          let item = this.querySelector('a');
          // item.classList.add('addUnderline');
          link2.classList.remove('d-none');
          link2.classList.add('d-block');
          console.log(item);
        });
        element.addEventListener('mouseleave', function () {
          if (element.id === 'Ratgeber') {
            link1.classList.add('d-none');
            link1.classList.remove('d-block');
          }
          if (element.id === 'Partner werden') {
            link2.classList.add('d-none');
            link2.classList.remove('d-block');
          }
          let item = this.querySelector('a');
        });
        link1.addEventListener('mouseleave', function () {
          let item = this.querySelector('a');
          link1.classList.add('d-none');
          link1.classList.remove('d-block');
        });
        link2.addEventListener('mouseleave', function () {
          let item = this.querySelector('a');
          link2.classList.add('d-none');
          link2.classList.remove('d-block');
        });
      });
    }
  };
  useEffect(() => {
    handleNav();
  }, []);
  return (
    <div>
      {' '}
      <div id='head'>
        <div className='container-xxl d-flex justify-content-between align-items-center py-2 py-lg-0 px-3 px-xxl-0'>
          <div className='d-flex flex-row align-items-center' style={{ gap: '0.5rem' }}>
            <p className='me-3 me-lg-5'>Wir organisieren Pflege.</p>
            <p className=''>
              <span>
                <img src={check} alt='user' className='mx-1' />
              </span>{' '}
              Erfahrung seit 1997
            </p>
          </div>
          <div
            className='d-flex flex-column flex-lg-row align-items-center'
            style={{ gap: '0.5rem' }}>
            <a href='#' className='me-2'>
              <u>Produkte im Set ändern</u>{' '}
            </a>
            <a href='' className='btn-login'>
              <span>
                <img src={User} alt='user' className='me-2' />
              </span>{' '}
              LOGIN
            </a>
          </div>
        </div>
      </div>
      <nav className='mb-3 navbar ' style={{ zIndex: 100 }}>
        <div className='container-xxl d-flex align-items-center px-4 px-xl-5 px-xxl-0 '>
          <div>
            <img src={logo} alt='' className='logo me-2 me-xl-4 py-2' />
          </div>
          <div
            className='nav-links align-items-center justify-content-between ps-3 ps-xl-5 '
            style={{ width: '100%' }}>
            <div className='hotline'>
              <p>Kostenlose Hotline</p>
              <p>
                {' '}
                <a href='tel:08005015637'>0 800 501 56 37</a>{' '}
              </p>
            </div>
            <div className='' style={{ zIndex: 10 }}>
              <ul className='d-flex'>
                <li className='hover-underline-animation py-5'>
                  {' '}
                  <a onClick={() => navigate('/')}>PflegehilfeSet erhalten</a>
                </li>
                <li className='hover-underline-animation py-5 menu-1-toggle nav-item' id='Ratgeber'>
                  <a onClick={() => navigate('/AdvisorPageOverview')}>Ratgeber</a>
                </li>
                <li className='hover-underline-animation py-5 nav-item' id='Partner werden'>
                  <a onClick={() => navigate('/AdvisorPageDetail')}>Partner werden</a>
                </li>
                <li className='hover-underline-animation py-5'>
                  <a onClick={() => navigate('/ContactForm')}>Kontakt</a>
                </li>
                <li className='hover-underline-animation py-5'>
                  <a onClick={() => navigate('/Landingpage')}>Pflegehilfsmittel</a>
                </li>
                <li className='d-flex align-items-center hover-underline-animation py-5'>
                  <a href='#'>
                    Shop{' '}
                    <span>
                      <img src={link} alt='shop' className='ms-1' />
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className='toggle-div'>
            <button id='toggle-button' onClick={() => setToggle(!toggle)}>
              <img src={hamburger} alt='open menu' />
            </button>
          </div>
        </div>
        <div
          className='d-none megamenu container-xxl'
          id='open-1'
          style={{ width: '100%', backgroundColor: 'white' }}>
          <div className='row gx-3'>
            <div className='col-3'>
              <h6 className='mb-4'>
                <a href='#'>Hilfe &amp; FAQs zur Bestellung</a>{' '}
              </h6>
              <h6>
                {' '}
                <a href=''>Häusliche Pflege </a>{' '}
              </h6>
              <p>
                {' '}
                <a href='#'>Pflege durch Angeherege</a>{' '}
              </p>
              <p>
                {' '}
                <a href='#'>PRegehilfe </a>
              </p>
              <h6>
                <a href=''>Krankheiten </a>{' '}
              </h6>
              <p>
                {' '}
                <a href=''>Standard Inkontinenz</a>{' '}
              </p>
              <p className='red'>
                <a href='#'>Dernenz</a>
              </p>
            </div>
            <div className='col-3'>
              <h6>
                <a href='#'>Pflegegrade </a>{' '}
              </h6>
              <p>
                {' '}
                <a href='#'>Pflegegrade 1</a>{' '}
              </p>
              <p>
                {' '}
                <a href='#'>Pflegegrade 2 </a>
              </p>
              <p>
                <a href=''>Pflegegrade 3 </a>{' '}
              </p>
              <p>
                {' '}
                <a href=''>Pflegegrade 4</a>{' '}
              </p>
              <p className=''>
                <a href='#'>Pflegegrade 5</a>
              </p>
              <p className=''>
                <a href='#'>Antrag auf Pflegegrad </a>
              </p>
            </div>
            <div className='col-3'>
              <h6>
                <a href='#'>Pflegekassen </a>{' '}
              </h6>
              <p className='red'>
                {' '}
                <a href='#'>AOK Kassen 1</a>{' '}
              </p>
              <p className='red'>
                {' '}
                <a href='#'> BKK Kassen</a>{' '}
              </p>
              <p className='red'>
                {' '}
                <a href='#'>DAK-Gesundheit</a>{' '}
              </p>
              <p className='red'>
                {' '}
                <a href='#'>Deteka BKK </a>{' '}
              </p>
              <p className='red'>
                {' '}
                <a href='#'> Hanseatische Krankenkasse</a>{' '}
              </p>
              <p className='red'>
                {' '}
                <a href='#'>IKK Kassen</a>{' '}
              </p>
              <p className='red'>
                {' '}
                <a href='#'>KKH</a>{' '}
              </p>
              <p className='red'>
                {' '}
                <a href='#'>Techniker Krankenkasse </a>{' '}
              </p>
            </div>
            <div className='col-3'>
              <h6>
                <a href='#'>Pflegereeht </a>{' '}
              </h6>
              <p>
                {' '}
                <a href='#'>Grundpflege </a>{' '}
              </p>
              <p>
                {' '}
                <a href='#'>Pfegebesürftigkeit </a>
              </p>
              <p>
                {' '}
                <a href=''> Pflegegrade und Leistungen</a>{' '}
              </p>
              <p className=''>
                <a href='#'>Pflegegeldstufen</a>
              </p>
              <p className=''>
                <a href='#'>Pflegesachleistungen </a>
              </p>
            </div>
          </div>
        </div>
        <div
          className='d-none megamenu container-xxl'
          id='open-2'
          style={{ width: '100%', backgroundColor: 'white' }}>
          <div className='row gx-3'>
            <div className='col-3'>
              <h6 className=''>
                <a href='#'>Inhalt des PlInehilleSets </a>{' '}
              </h6>
              <p>
                {' '}
                <a href='#'>Bett schutzenlagen </a>{' '}
              </p>
              <p>
                {' '}
                <a href='#'>Hancledeunfekten </a>
              </p>
              <h6>
                <a href=''>flachendeunfektch </a>{' '}
              </h6>
              <p>
                {' '}
                <a href=''>Mundschutz </a>{' '}
              </p>
              <p>
                <a href='#'>Fingerlinge </a>
              </p>
              <p>
                <a href='#'>Schutzschurze </a>
              </p>
              <p>
                <a href='#'>Einmalhandschuhe </a>
              </p>
              <p>
                <a href='#'>inkontherunlaerlal </a>
              </p>
            </div>
            <div className='col-3'>
              <h6>
                <a href='#'>Pflegehersmittelverzerchnis </a>{' '}
              </h6>
              <p>
                {' '}
                <a href='#'> Plegend nmnietraufe 1</a>{' '}
              </p>
              <p>
                {' '}
                <a href='#'>Plegehtlfsmtttel liste </a>
              </p>
              <p>
                <a href=''>PflegehtlfsmntelPauschale </a>{' '}
              </p>
              <p>
                {' '}
                <a href=''>Pflegeboa</a>{' '}
              </p>
              <p className=''>
                <a href='#'>PIegeneisnuztet zum Verbrauch</a>
              </p>
            </div>
            <div className='col-3'>
              <h6>
                <a href='#'>Pflegehilfsmittel beantragen </a>{' '}
              </h6>
              <p>
                {' '}
                <a href='#'>Pf tegehehmetel gratis erhalten</a>{' '}
              </p>
              <p>
                {' '}
                <a href='#'> Pflegehilfsmtnel bestellen</a>{' '}
              </p>
              <p>
                {' '}
                <a href='#'>Antrag auf Pfleghtlfsmettel</a>{' '}
              </p>
            </div>
          </div>
        </div>
        {toggle && (
          <div className='nav-links-mobile px-4 py-3' id='nav-menu-mobile'>
            <div className=''>
              <ul className=''>
                <li>
                  {' '}
                  <a href='#'>PflegehilfeSet erhalten</a>
                </li>
                <li>
                  <a href='#'>Ratgeber</a>
                </li>
                <li>
                  <a href='#'>Pflegehilfsmittel</a>
                </li>
                <li>
                  <a href='#'>Partner werden</a>
                </li>
                <li>
                  <a href='#'>Kontakt</a>
                </li>
                <li className='d-flex align-items-center'>
                  <a href='#'>
                    Shop{' '}
                    <span>
                      <img src={link} alt='shop' className='ms-1' />
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className='hotline pt-4 pb-4' style={{ textAlign: 'center' }}>
              <p>Kostenlose Hotline</p>
              <p>
                {' '}
                <a href='tel:08005015637'>0 800 501 56 37</a>{' '}
              </p>
            </div>
            <div className='d-flex flex-column align-items-center pb-3' style={{ gap: '1rem' }}>
              <a href='#' className='me-2'>
                <u>Produkte im Set ändern</u>{' '}
              </a>
              <a href='' className='btn-login px-5 py-3' style={{ fontSize: '1rem' }}>
                <span>
                  <img src={User} alt='user' className='me-2' />
                </span>
                LOGIN
              </a>
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;
